<script>
    import store from '../../../script/store/checkout';
    import CustomerForm from '../../business/customer/customer-form/CustomerForm.vue';
    import TextField from '../../../components/input/text-field/TextField.vue';
    import LoadingButton from '../../common/LoadingButton.vue';
    import Alert from '../../surface/alert/Alert.vue';
    import { AUTHENTICATION_STATUS, CHECKOUT_STEPS } from '../../../script/store/checkout/consts';
    import { customerService } from '../../../service/resource';
    import { readCookie, setCookie } from '../../../script/common';
    import cr$ from '../../../script/crquery';
    import { initializeSocialSignIn } from '../../../script/cadastro';

    export default {
        name: 'BaseCheckoutAuthentication',

        components: { CustomerForm, TextField, LoadingButton, Alert },

        props: {
            summarize: Boolean,
        },

        data() {
            return {
                ...CHECKOUT_STEPS,
                ...AUTHENTICATION_STATUS,

                storeState: store.state,

                fastLoginEmail: '',
                fastLoginEmailError: null,
                alert: null,

                fbInitialized: false,

                fastPassword: '',
                fastPasswordError: null,

                fastCustomer: undefined,
                registerApiErrors: null,

                loading: false,

                firstReset: true,
            };
        },

        watch: {
            activeStep: {
                immediate: true,
                handler(to, from) {
                    if (!to || to !== this.STEP_AUTHENTICATION) {
                        return;
                    }

                    if (this.authenticationStatus === this.AUTH_OK_STATE) {
                        this.resetState();
                    }

                    if (
                        this.authenticationStatus === this.AUTH_OK_STATE ||
                        this.authenticationStatus === this.AUTH_NEED_LOGIN ||
                        this.authenticationStatus === this.AUTH_NEED_LOGIN_TO_EDIT
                    ) {
                        this.initializaSocials();
                    }
                },
            },

            authenticationStatus: {
                immediate: true,
                handler(to) {
                    this.alert = null;

                    if (to === this.AUTH_OK_STATE) {
                        this.initializaSocials();
                    } else if (to === this.AUTH_NEW_ACCOUNT) {
                        this.fastCustomer = undefined;
                    }
                },
            },
        },

        computed: {
            cart() {
                return this.storeState.cart.cart;
            },

            authenticationStatus() {
                return this.storeState.authentication.authenticationStatus;
            },

            customer() {
                return (this.cart.customer || {}).data;
            },

            activeStep() {
                return this.storeState.step.active;
            },

            isBusy() {
                return !!store.isBusy();
            },

            allowChangeAuth() {
                return store.authentication.allowChangeAuth();
            },

            allowSocialLogin() {
                return this.$scope.TENANT_IDENTIFIER === 'chicorei';
            },
        },

        mounted() {
            if (this.allowSocialLogin) {
                initializeSocialSignIn();
            }
        },

        methods: {
            initializaSocials() {
                if (!this.allowSocialLogin) {
                    return;
                }

                if (!this.fbInitialized) {
                    let scriptElementFacebook = document.createElement('script');
                    scriptElementFacebook.setAttribute(
                        'src',
                        'https://connect.facebook.net/pt_BR/sdk.js#xfbml=1&version=v3.3&appId=416962708352552'
                    );
                    scriptElementFacebook.setAttribute('type', 'text/javascript');
                    scriptElementFacebook.setAttribute('crossorigin', 'anonymous');
                    document.body.appendChild(scriptElementFacebook);
                    this.fbInitialized = true;
                }

                let scriptElementGmail = document.createElement('script');
                scriptElementGmail.setAttribute(
                    'src',
                    'https://accounts.google.com/gsi/client?hl=pt'
                );
                scriptElementGmail.setAttribute('type', 'text/javascript');
                document.body.appendChild(scriptElementGmail);

                this.$nextTick(() => {
                    if (window.gapi) {
                        window.gapi.signin2.render('google-sign-in-button');
                    }
                });
            },

            isEmailValid() {
                return /^[a-z0-9!#$%&'*+\/=?^`{}|~_-]+[.a-z0-9!#$%&'*+\/=?^`{}|~_-]*@[a-z0-9]+[._a-z0-9-]*\.[a-z0-9]+$/iu.test(
                    this.fastLoginEmail
                );
            },

            validateEmail() {
                if (!this.fastLoginEmail || this.fastLoginEmail.trim().length === 0) {
                    this.fastLoginEmailError = 'Informe seu email';
                } else if (!this.isEmailValid(this.email)) {
                    this.fastLoginEmailError = 'Email inválido';
                } else {
                    this.fastLoginEmailError = null;
                }
            },

            validatePassword() {
                if (!this.fastPassword || this.fastPassword.trim().length === 0) {
                    this.fastPasswordError = 'Informe sua senha';
                } else if (this.fastPassword.trim().length > 254) {
                    this.fastPasswordError = 'Senha muito longa';
                } else if (this.fastPassword.trim().length < 6) {
                    this.fastPasswordError = 'Senha muito curta';
                } else {
                    this.fastPasswordError = null;
                }
            },

            fastAuthenticate() {
                this.validateEmail();

                if (this.fastLoginEmailError) {
                    return;
                }

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    user_email: this.fastLoginEmail,
                });
                store.authentication.setFastLoginEmail(this.fastLoginEmail);
            },

            fastLogin() {
                this.validatePassword();

                if (this.fastPasswordError || this.loading) {
                    return;
                }

                this.doLogin(this.fastLoginEmail, this.fastPassword);
            },

            doLogin(email, password) {
                this.loading = true;

                let payload = new FormData();
                payload.append('email', email);
                payload.append('password', password);

                this.axios.http
                    .post('/login.php', payload)
                    .then((response) => {
                        let d = new Date();
                        d.setTime(d.getTime() + 100 * 24 * 60 * 60 * 1000);
                        setCookie('fast_register_warn', '1', d);

                        if (response.data.success) {
                            window.location.href = '/sacola/checkout';
                        } else {
                            this.fastPasswordError =
                                'Não foi possível realizar o login. Verifique seu email e senha.';
                        }
                    })
                    .catch(() => {
                        this.fastPasswordError =
                            'Não foi possível realizar o login. Verifique seu email e senha.';
                    })
                    .then(() => (this.loading = false));
            },

            fbLogin() {
                if (!window.FB) {
                    return;
                }

                window.FB.login(
                    function (response) {
                        if (response.authResponse) {
                            window.onFacebookSignIn(response);
                        } else {
                            console.log('User cancelled login or did not fully authorize.');
                        }
                    },
                    {
                        scope: 'public_profile,email',
                    }
                );
            },

            submitRegister() {
                this.loading = true;
                const postData = {
                    utm_source: readCookie('utm_source'),
                    utm_campaign: readCookie('utm_campaign'),
                    fast_register: 1,
                };
                customerService
                    .save(this.fastCustomer, postData)
                    .then(() => {
                        this.doLogin(this.fastCustomer.email, this.fastCustomer.password);
                    })
                    .catch((response) => {
                        this.loading = false;
                        this.showError(
                            ((response.response || {}).data || {}).errors
                                ? 'Por favor, preencha os campos corretamente'
                                : 'Não foi possível enviar seus dados'
                        );

                        if (response.response && response.response.data.errors) {
                            this.registerApiErrors = response.response.data.errors;

                            if (
                                this.registerApiErrors['email'] &&
                                this.registerApiErrors['email'][0]
                            ) {
                                this.fastLoginEmailError = this.registerApiErrors['email'][0];
                            }
                        }
                    });
            },

            showError(error) {
                cr$.byEl(this.$refs.alertAnchor).scrollIntoView();

                this.alert = {
                    message: error,
                    isError: true,
                    timeout: 20000,
                };
            },

            forceLogin() {
                store.authentication.authGuard(() => {});
            },

            resetState() {
                if (this.firstReset) {
                    this.firstReset = false;
                    this.fastLoginEmail = readCookie('fast_login');
                } else {
                    this.fastLoginEmail = '';
                    store.authentication.setFastLoginEmail(this.fastLoginEmail);
                }
            },
        },
    };
</script>
